import AccountBillingInformation from '../../../components/hub/account/AccountBillingInformation/AccountBillingInformation';
import useAccountDetailsQuery from '../../../hooks/queries/useAccountDetailsQuery';
import useBillingInformationQuery from '../../../hooks/queries/useBillingInformationQuery';
import AccountPageLayout from '../../../templates/AccountPageLayout/AccountPageLayout';
import AccountBalance from '../components/AccountBalance';
import InvoicesList from '../components/InvoicesList/InvoicesList';

const PaymentBillingPage = () => {
  const {
    data: billingInformation,
    isLoading: isLoadingBillingInformation,
    error: getBillingInformationError,
  } = useBillingInformationQuery();

  const { isLoading: isLoadingAccountDetails } = useAccountDetailsQuery();

  return (
    <AccountPageLayout loading={isLoadingBillingInformation || isLoadingAccountDetails}>
      <div className="mb-10 rounded-3xl border border-grey-100 bg-white p-10">
        <h2 className="mb-0 font-display text-2xl font-bold">Payment and billing details</h2>
        <AccountBillingInformation billingInformation={billingInformation} error={getBillingInformationError} />
        <AccountBalance billingInformation={billingInformation} error={getBillingInformationError} />
        <InvoicesList />
      </div>
    </AccountPageLayout>
  );
};

export default PaymentBillingPage;
